import * as React from 'react';
import PropTypes from 'prop-types';
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import { useTheme } from '@emotion/react';
import Tooltip from '@mui/material/Tooltip';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';
import { visuallyHidden } from '@mui/utils';
import { useState } from 'react';
import { useEffect } from 'react';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Chip, Menu, MenuItem, TextField, Stack, Grid } from '@mui/material';
import useAxiosPrivate from '../../hooks/use-axios-private';
import { alertMsg } from '../../utils/basicUtils';
import Empty from '../../components/Empty';
import moment from 'moment';
import { DateRange } from 'react-date-range';
import { APP_DATE_FORMAT, JOB_STATUS, ROLE } from '../../constants';
import useAuth from '../../hooks/use-auth';
import CountdownTimer from '../../components/CountDownTimer';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Avatar from '@mui/material/Avatar';
import AvatarGroup from '@mui/material/AvatarGroup';
import Zoom from '@mui/material/Zoom';
import EditorPicker from '../user/EditorPicker';
import Badge from '@mui/material/Badge';
import ModalBox from '../../components/ModalBox';
import { Field, Form, Formik } from 'formik';
import { TextField as FormikTextField } from 'formik-mui';
import * as Yup from 'yup';
import Popup from '../../components/Popup';
import StrictNumberField from '../../components/StrictNumberField';

const getStatusColor = (status) => {
    switch (status) {
        case JOB_STATUS.pending:
            return 'warning'//yellow
        case JOB_STATUS.inprogress:
            return 'info'//blue
        case JOB_STATUS.completed:
            return 'success'//green
        case JOB_STATUS.cancel_req:
            return 'warning'
        case JOB_STATUS.cancelled:
            return 'error'
        case JOB_STATUS.hold:
            return 'warning'
        case JOB_STATUS.trash:
            return 'error'
        default:
            return 'error'//red
    }
}

const getStatusName = (status) => {
    switch (status) {
        case JOB_STATUS.pending:
            return 'Pending'//yellow
        case JOB_STATUS.inprogress:
            return 'In progress'//blue
        case JOB_STATUS.completed:
            return 'Completed'//green
        case JOB_STATUS.cancel_req:
            return 'Cancel requested'
        case JOB_STATUS.cancelled:
            return 'Canceled'
        case JOB_STATUS.hold:
            return 'Hold'
        case JOB_STATUS.trash:
            return 'Trash'
        default:
            return 'unknown'//red
    }
}

let headCellsObj = [
    {
        id: 'id',
        numeric: false,
        disablePadding: true,
        label: 'Order ID',
    },
    {
        id: 'title',
        numeric: true,
        disablePadding: false,
        label: 'Job Title',
    },
    {
        id: 'worktype',
        numeric: true,
        disablePadding: false,
        label: 'Type Of Work',
    },
    {
        id: 'created_on',
        numeric: true,
        disablePadding: false,
        label: 'Created on - Deliver on',
    },
    {
        id: 'created_by',
        numeric: true,
        disablePadding: false,
        label: 'Created by',
    },
    {
        id: 'status',
        numeric: true,
        disablePadding: false,
        label: 'Status',
    },
    // {
    //     id: 'delivery_time',
    //     numeric: true,
    //     disablePadding: false,
    //     label: 'Deliver Time',
    // },
    {
        id: 'action',
        numeric: true,
        disablePadding: false,
        label: 'Action',
    },

];

const EnhancedTableHead = (props) => {
    const { order, orderBy, onRequestSort } = props;
    const { protector } = useAuth()
    const [headCells, setHeadCells] = useState([])
    useEffect(() => {
        protector([ROLE.admin]) ? setHeadCells(headCellsObj) : setHeadCells(headCellsObj.filter(cell => cell.id !== 'created_by'))
    }, [])
    const createSortHandler = (newOrderBy) => {
        onRequestSort(newOrderBy);
    };
    return (
        <TableHead>
            <TableRow sx={{ height: { xs: 65, xl: 75 } }}>
                {/* <TableCell padding="checkbox">
                    <Checkbox
                        color="primary"
                        indeterminate={numSelected > 0 && numSelected < rowCount}
                        checked={rowCount > 0 && numSelected === rowCount}
                        onChange={onSelectAllClick}
                        inputProps={{
                            'aria-label': 'select all desserts',
                        }}
                    />
                </TableCell> */}
                {
                    headCells.map((headCell, index) => (
                        <TableCell
                            key={index}
                            align={'center'}
                            // padding={headCell.disablePadding ? 'none' : 'normal'}
                            sortDirection={orderBy === headCell.id ? order : false}
                            sx={{ whiteSpace: "nowrap" }}
                        >

                            {
                                headCell.id !== 'action'
                                    ?
                                    <TableSortLabel
                                        active={orderBy === headCell.id}
                                        direction={orderBy}
                                        onClick={() => createSortHandler(headCell.id)}
                                    >
                                        {headCell.label}
                                        {orderBy === headCell.id && (
                                            <Box component="span" sx={visuallyHidden}>
                                                {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                            </Box>
                                        )
                                        }
                                    </TableSortLabel>
                                    :
                                    headCell.label
                            }
                        </TableCell>
                    ))}
                <TableCell></TableCell>
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    //  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    // orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};

const EnhancedTableToolbar = (props) => {
    const theme = useTheme();
    const [showFilter, setShowFilter] = useState(false)
    const [toggleDatePicker, setToggleDatePicker] = useState(false)
    const { numSelected, onSearchChange, filterChange } = props
    const [appliedFilter, setAppliedFilter] = useState("ALL")
    const [filterCondition, setFilterCondition] = useState(
        {
            startDate: new Date(),
            endDate: new Date(),
            key: 'selection'
        }
    )

    const onFilterChange = (e) => {
        if (e !== "CUSTOM") {
            setAppliedFilter(e)
        }
        if (e === "CUSTOM") {
            setToggleDatePicker(true)
            return
        }
        else if (e === "7DAYS") {
            const date = new Date()
            const currentDate = moment(date)
            const sevenDays = date.setDate(date.getDate() - 6)
            const last7Days = moment(sevenDays)
            const filterCondition = {
                startDate: moment.utc(last7Days).format(),
                endDate: moment.utc(currentDate).format(),
            }
            filterChange(filterCondition)
        }

        else if (e === "LST_30_DAYS") {
            const date = new Date()
            const currentDate = moment(date)
            const thirtyDays = date.setDate(date.getDate() - 30)
            const last30Days = moment(thirtyDays)
            const filterCondition = {
                startDate: moment.utc(last30Days).format(),
                endDate: moment.utc(currentDate).format(),
            }
            filterChange(filterCondition)
        }

        else if (e === "LST_MONTH") {
            const date = new Date()
            const currentYear = date.getFullYear()
            const month = date.setMonth(date.getMonth() - 1)
            const NumberOfDaysInMonth = new Date(month);
            const firstDay = new Date(currentYear, NumberOfDaysInMonth.getMonth(), 1);
            let lastDay = new Date(currentYear, NumberOfDaysInMonth.getMonth() + 1, 0);
            const filterCondition = {
                startDate: moment.utc(firstDay).format(),
                endDate: moment.utc(lastDay).format(),
            }
            filterChange(filterCondition)
        }

        else if (e === "LST_3_MONTH") {
            const date = new Date()
            const currentYear = date.getFullYear()
            const setLast3Month = date.setMonth(date.getMonth() - 3)

            const setLastmonth = date.setMonth(date.getMonth() + 2)

            const lastMonth = new Date(setLastmonth);

            const last3Month = new Date(setLast3Month);

            const firstDay = new Date(currentYear, last3Month.getMonth(), 1);

            const lastDay = new Date(currentYear, lastMonth.getMonth() + 1, 0);

            const filterCondition = {
                startDate: moment.utc(firstDay).format(),
                endDate: moment.utc(lastDay).format(),
            }
            filterChange(filterCondition)
        }

        else if (e === "ALL") {
            const filterCondition = {
                startDate: '',
                endDate: '',
            }
            filterChange(filterCondition)
        }
        setShowFilter(false)
    }
    return (
        <Toolbar
            sx={{
                px: { xs: 2, sm: 3 },
                ...(numSelected > 0 && {
                    bgcolor: (theme) =>
                        alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
                }),
                alignItems: { xs: 'end' }
            }}
        >
            {numSelected > 0 ? (
                <Typography
                    sx={{ flex: '1 1 100%' }}
                    color="inherit"
                    variant="subtitle1"
                    component="div"
                >
                    {numSelected} selected
                </Typography>
            ) : (
                <Stack direction={{ xs: 'column', sm: 'row' }} alignItems={{ xs: 'start', md: 'end' }} justifyContent='space-between' sx={{ width: '100%', mt: { xs: 3, sm: 0 } }}>
                    <Typography
                        sx={{ flex: '1 1 100%', color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main, fontSize: { xs: 18, xl: 20 }, fontWeight: 500 }}
                        id="tableTitle"
                        component="div"
                    >
                        Jobs
                    </Typography>
                    <Box sx={{ mr: 3, width: { xs: '100%', sm: 300 }, maxWidth: '100%', }}>
                        <TextField fullWidth label="Search" variant="standard" size="small" type='search' onChange={onSearchChange} autoComplete='off' />
                    </Box>
                </Stack>
            )}

            {numSelected > 0 ? (
                <>
                    <Tooltip title="Delete">
                        <IconButton color='error'>
                            <DeleteOutlineOutlinedIcon />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Duplicate">
                        <IconButton>
                            <ContentCopyOutlinedIcon />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Edit">
                        <IconButton>
                            <EditOutlinedIcon />
                        </IconButton>
                    </Tooltip>
                </>
            ) : (
                <>
                    <Tooltip title="Filter">
                        <Badge overlap="circular" badgeContent=" " color="secondary" invisible={appliedFilter === 'ALL'} variant="dot">
                            <IconButton sx={{ backgroundColor: '#f3f3f3' }} onClick={(e) => {
                                setShowFilter(prev => {
                                    return prev ? false : e.target
                                })

                            }}>
                                <FilterAltOutlinedIcon />
                            </IconButton>
                        </Badge>
                    </Tooltip>

                    <Menu
                        open={showFilter}
                        anchorEl={showFilter}
                        onClose={() => { setShowFilter(false); setToggleDatePicker(false) }}
                    >
                        {toggleDatePicker ?
                            <DateRange
                                maxDate={new Date()}
                                editableDateInputs={true}
                                onChange={(item) => {
                                    setFilterCondition(item.selection)
                                    let nextDay = new Date(item.selection.endDate.getTime())
                                    nextDay.setHours(item.selection.endDate.getHours() + 24)
                                    let lastDate = moment.utc(item.selection.endDate).format()
                                    if (item.selection.startDate.getTime() === item.selection.endDate.getTime()) {
                                        lastDate = moment.utc(nextDay).format()
                                    }
                                    lastDate = moment(lastDate).set({ 'hour': 23, 'minute': 59, 'second': 59 })
                                    filterChange(
                                        {
                                            startDate: moment.utc(item.selection.startDate).format(),
                                            endDate: moment.utc(lastDate).format(),
                                        }
                                    )
                                    setAppliedFilter("CUSTOM")
                                }}
                                moveRangeOnFirstSelection={false}
                                ranges={[filterCondition]}
                            />
                            :
                            <Box>
                                <MenuItem onClick={() => onFilterChange('ALL')} sx={appliedFilter === "ALL" ? { background: "#ebecf0", borderLeft: "3px solid #0b1345", fontWeight: 500, fontSize: '15px' } : { fontSize: '15px', borderLeft: "3px solid transparent" }} >All</MenuItem>
                                <MenuItem onClick={() => onFilterChange('7DAYS')} sx={appliedFilter === "7DAYS" ? { background: "#ebecf0", borderLeft: "3px solid #0b1345", fontWeight: 500, fontSize: '15px' } : { fontSize: '15px', borderLeft: "3px solid transparent" }}>Last 7 days</MenuItem>
                                <MenuItem onClick={() => onFilterChange('LST_30_DAYS')} sx={appliedFilter === "LST_30_DAYS" ? { background: "#ebecf0", borderLeft: "3px solid #0b1345", fontWeight: 500, fontSize: '15px' } : { fontSize: '15px', borderLeft: "3px solid transparent" }}>Last 30 days</MenuItem>
                                <MenuItem onClick={() => onFilterChange('LST_MONTH')} sx={appliedFilter === "LST_MONTH" ? { background: "#ebecf0", borderLeft: "3px solid #0b1345", fontWeight: 500, fontSize: '15px' } : { fontSize: '15px', borderLeft: "3px solid transparent" }}>Last month</MenuItem>
                                <MenuItem onClick={() => onFilterChange('LST_3_MONTH')} sx={appliedFilter === "LST_3_MONTH" ? { background: "#ebecf0", borderLeft: "3px solid #0b1345", fontWeight: 500, fontSize: '15px' } : { fontSize: '15px', borderLeft: "3px solid transparent" }}>Last 3 months</MenuItem>
                                <MenuItem onClick={() => onFilterChange('CUSTOM')} sx={appliedFilter === "CUSTOM" ? { background: "#ebecf0", borderLeft: "3px solid #0b1345", fontWeight: 500, fontSize: '15px' } : { fontSize: '15px', borderLeft: "3px solid transparent" }}>Custom range</MenuItem>
                            </Box>
                        }
                    </Menu>
                </>
            )}
        </Toolbar>
    );
}

EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
};

const JobAction = ({ job, onActionComplete }) => {
    const axios = useAxiosPrivate()
    const [showUserPicker, setShowUserPicker] = useState(false)
    const [isEditable, setIsEditable] = useState(false);
    const [selectedEditors, setSelectedEditors] = useState([])
    const [reAssign, setReAssign] = useState(false)
    const navigate = useNavigate()
    const { protector } = useAuth()
    const theme = useTheme()
    const [open, setOpen] = useState(false)
    const [alertModelOpen, setAlertModelOpen] = useState(false)
    const handleClick = (event) => {
        setIsEditable(event.currentTarget);
    };
    const handleClose = () => {
        setIsEditable(null);
    };
    const assignJob = async (assignee) => {
        try {
            const resp = await axios.post('jobs/assign/', {
                job_id: job.job_id,
                assigned_to: assignee,
            })
            setShowUserPicker(false)
            onActionComplete()
            alertMsg(resp.data.message, 'success')
        }
        catch (err) {
            console.error("🚀 ~ file: JobList.jsx:409 ~ assignJob ~ err:", err)
        }
    }
    const completeJob = async (jobId) => {
        try {
            const resp = await axios.post('jobs/completed/', {
                job_id: jobId,
            })
            setShowUserPicker(false)
            onActionComplete()
            alertMsg(resp.data.message, 'success')

        }
        catch (err) {
            console.error("🚀 ~ file: JobList.jsx:409 ~ assignJob ~ err:", err)
        }
    }

    const deleteJob = async () => {
        try {
            const resp = await axios.delete(`jobs/${job.job_id}`)
            onActionComplete()
            alertMsg(resp.data.message, 'success')

        }
        catch (err) {
            console.error("🚀 ~ file: JobList.jsx:460 ~ deleteJob ~ err:", err)
        }
    }
    const revertJob = async () => {
        try {
            const resp = await axios.post("/jobs/revert/",
                {
                    job_id: job.job_id
                }
            )
            setIsEditable(false);
            onActionComplete()
            alertMsg(resp.data.message, 'success')
        }
        catch (err) {
            console.error("🚀 ~ file: JobList.jsx:409 ~ assignJob ~ err:", err)
        }
    }
    return (
        <Box sx={{ display: "flex" }}>
            {
                protector([
                    ROLE.qc,
                    ROLE.admin,
                    ROLE.sa
                ]) &&
                <Box onClick={(e) => { e.stopPropagation() }}>
                    {
                        job.status === JOB_STATUS.pending &&
                        <>
                            <Button
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setShowUserPicker(true)
                                    setSelectedEditors([])
                                    setReAssign(false)
                                }} sx={{ minWidth: 80, fontSize: 12 }} variant="outlined" size="small">Assign</Button>
                            <IconButton
                                onClick={handleClick}
                                size="small"
                                sx={{ ml: .5 }}
                            >
                                <MoreVertIcon />
                            </IconButton>
                            <Menu
                                anchorEl={isEditable}
                                open={isEditable}
                                onClose={handleClose}
                            >
                                <MenuItem onClick={deleteJob}>Delete</MenuItem>
                                {/* <MenuItem onClick={handleClose}>Edit</MenuItem> */}
                            </Menu>
                        </>
                    }
                    {
                        job.status === JOB_STATUS.inprogress &&
                        <Box>
                            <Stack direction="row" alignItems="center" justifyContent="end">
                                <Box sx={{ textTransform: 'capitalize' }}>
                                    {job.assigned_to && job.assigned_to.length > 0 && (
                                        job.assigned_to.length === 1 ?
                                            <Stack direction="row" alignItems="center" spacing={.5} my={.6}>
                                                <PersonOutlineIcon sx={{ fontSize: 12 }} />
                                                <Typography variant="span" fontSize={12} sx={{ textTransform: 'capitalize' }}>{job.assigned_to[0].first_name}</Typography>
                                            </Stack>
                                            : <AvatarGroup max={4} sx={{ textTransform: 'capitalize', '& .MuiAvatar-root': { width: 22, height: 22, fontSize: 12, my: .5, backgroundColor: theme.palette.primary.main, borderColor: "#FFF", color: "#fff" } }}>
                                                {
                                                    job.assigned_to.map((assignee, index) => {
                                                        return <Tooltip arrow key={index} title={assignee?.first_name[0].toUpperCase() + assignee.first_name.slice(1)} placement="top" TransitionComponent={Zoom} TransitionProps={{ timeout: 600 }}>
                                                            <Avatar sx={{ textTransform: "uppercase" }}>{assignee.first_name.charAt(0)}</Avatar>
                                                        </Tooltip>
                                                    })
                                                }
                                            </AvatarGroup>
                                    )}
                                    <Button
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            completeJob(job.job_id)
                                        }}
                                        sx={{ minWidth: 80, fontSize: 12 }} variant="outlined" size="small">Complete</Button>
                                </Box>
                                <IconButton
                                    onClick={handleClick}
                                    size="small"
                                    sx={{ ml: .5 }}
                                >
                                    <MoreVertIcon />
                                </IconButton>
                                <Menu
                                    anchorEl={isEditable}
                                    open={isEditable}
                                    onClose={handleClose}
                                >
                                    <MenuItem
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            revertJob()
                                        }}
                                    >Revert</MenuItem>
                                    <MenuItem onClick={deleteJob}>Delete</MenuItem>
                                    <MenuItem
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setShowUserPicker(true)
                                            setSelectedEditors(job.assigned_to.map(editor => editor.id))
                                            setReAssign(true)
                                            handleClose()
                                        }}
                                    >ReAssign Editor</MenuItem>
                                </Menu>
                            </Stack>
                        </Box>
                    }

                    {
                        job.status === JOB_STATUS.completed &&
                        <Box>
                            <Button
                                sx={{ minWidth: 80, fontSize: 12, mr: "38px" }}
                                onClick={(e) => {
                                    navigate(`/jobs/${job.job_id}`)
                                }} variant="outlined" size="small">View job</Button>
                        </Box>
                    }

                    {
                        showUserPicker && <EditorPicker
                            multiple={true}
                            title={"Select Editor"}
                            role={ROLE.editor}
                            onClose={() => { setShowUserPicker(false) }}
                            setSelectedEditors={setSelectedEditors}
                            onSubmit={(editorId) => assignJob(editorId)}

                            selectedEditors={selectedEditors}
                            reAssign={reAssign}
                        />
                    }
                </Box >
            }

            {
                protector([ROLE.editor]) && job.status === JOB_STATUS.inprogress &&
                <Box onClick={(e) => { e.stopPropagation() }}>
                    <IconButton
                        onClick={handleClick}
                        size="small"
                        sx={{ ml: .5 }}
                    >
                        <MoreVertIcon />
                    </IconButton>
                    <Menu
                        anchorEl={isEditable}
                        open={isEditable}
                        onClose={handleClose}
                    >
                        <MenuItem
                            onClick={(e) => {
                                e.stopPropagation()
                                setOpen(true)
                                handleClose()
                            }}
                        >Add Report</MenuItem>
                    </Menu>
                </Box>
            }
            <Box onClick={(e) => { e.stopPropagation() }}>
                <ModalBox
                    open={open}
                    onClose={() => { setOpen(false) }} >
                    <Box sx={{ mb: 2 }}>
                        <Typography sx={{ color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main, fontSize: { xs: 20, xl: 22 }, fontWeight: '400' }}>Report</Typography>
                    </Box>
                    <Formik
                        initialValues={{
                            job_id: job.id,
                            completed_files: '',
                            is_approved: false
                        }}
                        validationSchema={Yup.object({
                            completed_files: Yup.number()
                                .required("Completed Files Required")
                                .integer("Completed Files must be an integer"),
                        })}
                        onSubmit={async (values, { setSubmitting }) => {
                            try {
                                const response = await axios.post("/reports/", values)
                                setOpen(false)
                                alertMsg(response.data.message, "success")
                                setSubmitting(false);
                            }
                            catch (error) {
                                console.error(error)
                            }
                        }}
                    >
                        <Form>
                            <Grid container spacing={{ xs: 2, md: 3 }} sx={{ pt: 2, }}>
                                <Grid item xs={12} sm={8} >
                                    <Box>
                                        <Field
                                            component={FormikTextField}
                                            name="job_name"
                                            label="Job Name "
                                            inputProps={{ maxLength: 35 }}
                                            variant="outlined"
                                            value={job.title}
                                            disabled={true}
                                            fullWidth
                                        />
                                    </Box>
                                </Grid>
                            </Grid>
                            <Grid container spacing={{ xs: 2, md: 3 }} sx={{ pt: 4, }}>
                                <Grid item xs={12} sm={6} >
                                    <Box>
                                        <StrictNumberField name="total_files" label="Total File" inputProps={{ maxLength: 35 }}
                                            value={job.media.length} disabled={true} component={FormikTextField} type="number" fullWidth />
                                    </Box>
                                </Grid>
                                <Grid item xs={12} sm={6} >
                                    <Box>
                                        <StrictNumberField name="completed_files" label="Completed File" inputProps={{ maxLength: 35 }} autoComplete='off' component={FormikTextField} type="number" fullWidth />
                                    </Box>
                                </Grid>
                            </Grid>
                            <Box sx={{ mt: 5, display: "flex", justifyContent: "end" }}>

                                <Box>
                                    <Button
                                        variant="outlined"
                                        color="primary"
                                        sx={{ mr: 2 }}
                                        onClick={() => { setOpen(false); setAlertModelOpen(false) }}
                                    >
                                        Cancel
                                    </Button>
                                </Box>
                                <Box>
                                    <Button type="submit" variant="contained" onClick={() => setAlertModelOpen(false)}>Save</Button>
                                </Box>
                            </Box>
                        </Form>
                    </Formik>
                </ModalBox>
            </Box>
            <Box onClick={(e) => { e.stopPropagation() }}>
                <Popup show={alertModelOpen} onSecondaryClick={() => setAlertModelOpen(false)} title={"Add Report"} consent={false} variant='warning' primaryBtnTxt={"Yes"} secondaryBtnTxt={"No"}
                    onPrimaryClick={() => setOpen(true)}
                >
                    <Box sx={{ mt: 2, textAlign: "center" }}>
                        <Typography variant='span' sx={{ fontSize: { xs: "16px", xl: "18px" }, fontWeight: "400", color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}> This job is not completed by </Typography>
                        <Typography variant='span' sx={{ fontSize: { xs: "16px", xl: "18px" }, fontWeight: "500", color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}> you .</Typography>
                        <Typography variant='span' sx={{ fontSize: { xs: "16px", xl: "18px" }, fontWeight: "400", color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}> Do you really want to continue</Typography>
                    </Box>
                </Popup>
            </Box>
        </Box>

    )
}

const JobList = ({ jobstatus, onChange }) => {
    const { protector } = useAuth()
    const [ascorder, setAscorder] = useState("desc")
    const [selected, setSelected] = useState([]);
    const [page, setPage] = useState(0);
    const [jobs, setJobs] = useState([]);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [paddingHeight, setPaddingHeight] = useState(0);
    const [searchText, setSearchText] = useState('');
    const [count, setCount] = useState(0);
    const navigate = useNavigate()
    const axios = useAxiosPrivate()

    const [orderByJobs, setOrderByJobs] = useState([])
    const [filter, setFilter] = useState(
        {
            startDate: '',
            endDate: '',
            key: 'selection'
        }
    );
    const getJobs = async () => {
        try {
            const resp = await axios.get('jobs/', {
                params: {
                    limit: rowsPerPage, search: searchText, page: page + 1, status: jobstatus
                    , order_by: orderByJobs, order_by_type: ascorder,
                    start_date: filter.startDate,
                    end_date: filter.endDate
                }
            })
            setJobs(resp.data.data.jobs)
            setCount(resp.data.data.page_info.count)
        } catch (error) {
            console.error("🚀 ~ file: JobList.jsx:295 ~ getJobs ~ error:", error)
        }
    }
    useEffect(() => {
        getJobs()
    }, [rowsPerPage, searchText, page, ascorder, orderByJobs, filter]);


    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            return;
        }
        setSelected([]);
    };
    const orderChange = (newOrderBy) => {
        if (newOrderBy === 'action') {
            return false
        }
        if (ascorder === "desc") {
            setAscorder("asc")
            setOrderByJobs(newOrderBy)
        }
        else {
            setAscorder("desc")
            setOrderByJobs(newOrderBy)
        }
    }

    const handleChangePage = useCallback(
        (event, newPage) => {
            setPage(newPage)
        },
        []
    );

    const handleChangeRowsPerPage = useCallback(
        (event) => {
            const updatedRowsPerPage = parseInt(event.target.value, 10);
            setRowsPerPage(updatedRowsPerPage);
            setPage(0);
            // There is no layout jump to handle on the first page.
            setPaddingHeight(0);
        }, []
    );
    const isSelected = order_id => selected.indexOf(order_id) !== -1;
    return (
        <Box sx={{ width: '100%' }}>
            <Paper sx={{ width: '100%', mb: 2, boxShadow: "2px 2px 12px 0px rgb(0 0 0 / 11%)" }}>
                <Box>
                    <EnhancedTableToolbar
                        numSelected={selected.length}
                        onSearchChange={
                            (e) => {
                                setSearchText(e.target.value)
                            }
                        }
                        filterChange={
                            (e) => {
                                setFilter(e)
                            }
                        }
                        filter={filter}
                    />

                    {jobs.length > 0
                        ?
                        <>
                            <TableContainer>
                                <Table
                                    sx={{ minWidth: 750, mt: 3 }}
                                    aria-labelledby="tableTitle"
                                    size={'small'}
                                >
                                    <EnhancedTableHead
                                        numSelected={selected.length}
                                        //   order={order}
                                        //  orderBy={orderBy}
                                        onSelectAllClick={handleSelectAllClick}

                                        //  onRequestSort={orderChange}
                                        onRequestSort={(newOrderBy) => { orderChange(newOrderBy) }}
                                        rowCount={jobs.length}
                                        orderBy={ascorder}
                                    />
                                    <TableBody>
                                        {jobs
                                            ? jobs.map((job, index) => {
                                                const isItemSelected = isSelected(job.id);
                                                const labelId = `enhanced-table-checkbox-${index}`;
                                                return (
                                                    <TableRow
                                                        hover
                                                        //  onClick={() => navigate(`/jobs/${job.job_id}`)}
                                                        onClick={() => {
                                                            !protector([ROLE.client]) &&
                                                                navigate(`/jobs/${job.job_id}`)
                                                        }}
                                                        role="checkbox"
                                                        aria-checked={isItemSelected}
                                                        tabIndex={-1}
                                                        key={job.id}
                                                        selected={isItemSelected}
                                                        // sx={{ cursor: 'pointer', height: { xs: 65, md: 75 } }}
                                                        sx={{ cursor: protector([ROLE.client]) ? "auto" : "pointer", height: { xs: 65, md: 65 } }}
                                                    >
                                                        <TableCell
                                                            component="th"
                                                            id={labelId}
                                                            scope="row"
                                                            align="center"
                                                            sx={{ whiteSpace: "nowrap" }}
                                                        >
                                                            {job.id}
                                                        </TableCell>
                                                        <TableCell align="center" sx={{ whiteSpace: "pre-wrap", minWidth: "250px", maxWidth: "250px", textTransform: "capitalize" }}>{job.title}</TableCell>
                                                        <TableCell align="center" sx={{ whiteSpace: "nowrap" }}>{job.service_lst ? job.service_lst[0].name : ''}</TableCell>
                                                        <TableCell align="center" sx={{ whiteSpace: "nowrap" }}>

                                                            <Box sx={{ mb: 1 }}>
                                                                <Typography sx={{ fontSize: '13px' }}>{moment(job.created_on).format(APP_DATE_FORMAT)}</Typography>
                                                            </Box>
                                                            <Box>
                                                                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: "green" }}>{moment(job.delivery_time).format(APP_DATE_FORMAT)}</Typography>
                                                            </Box>
                                                            {/* {moment(job.created_on).format("MM/DD/YYYY HH:mm A")} */}
                                                        </TableCell>
                                                        {protector([ROLE.sa, ROLE.admin]) &&
                                                            // <TableCell align="center" sx={{ whiteSpace: "pre-wrap", minWidth: "250px", maxWidth: "250px", textTransform: "capitalize" }}>{job.user_name}</TableCell>}
                                                            <TableCell align="center" sx={{ whiteSpace: "pre-wrap", minWidth: "250px", maxWidth: "250px" }}>
                                                                <Box sx={{ mb: 1 }}>
                                                                    <Typography sx={{ fontSize: '13px', fontWeight: 500 }}>{job.user_name}</Typography>
                                                                </Box>
                                                                <Box>
                                                                    <Typography sx={{ fontSize: '13px' }}>{job.user_email}</Typography>
                                                                </Box>
                                                            </TableCell>}
                                                        <TableCell align="center" sx={{ whiteSpace: "nowrap" }}> <Chip label={getStatusName(job.status)} color={getStatusColor(job.status)} sx={{ textTransform: "capitalize" }} /></TableCell>

                                                        {protector([ROLE.client]) &&
                                                            <TableCell align="center" sx={{ whiteSpace: "nowrap" }}>
                                                                <Button
                                                                    sx={{ minWidth: 80, fontSize: 12 }}
                                                                    onClick={(e) => {
                                                                        navigate(`/jobs/${job.job_id}`)
                                                                    }} variant="outlined" size="small">View Job</Button>
                                                            </TableCell>
                                                        }

                                                        <TableCell align="right" sx={{ whiteSpace: "nowrap" }}>
                                                            <JobAction job={job} onActionComplete={() => { getJobs(); onChange() }} />
                                                        </TableCell>
                                                        <TableCell></TableCell>
                                                    </TableRow>
                                                );
                                            })
                                            : null}
                                        {paddingHeight > 0 && (
                                            <TableRow
                                                style={{
                                                    height: paddingHeight,
                                                }}
                                            >
                                                <TableCell colSpan={6} />
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <TablePagination
                                rowsPerPageOptions={[5, 10, 25]}
                                component="div"
                                count={count}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                            />
                        </>
                        :
                        <Empty sx={{ border: "none", }} icon={<WorkOutlineIcon sx={{ fontSize: 40, color: "grey" }} />} text="No jobs available" >
                            <Box sx={{ textAlign: "center", my: 2 }}>
                                <Button variant='contained'
                                    onClick={() => {
                                        navigate('/jobs/create')
                                    }}
                                >Create Job / Upload Images</Button>
                            </Box>
                        </Empty>
                    }
                </Box>
            </Paper>
        </Box>
    );
}
JobList.defaultProps = {
    jobstatus: 0,
    onChange: () => { }
}

export default JobList